import { Component } from '@verndale/core';

class BackToSearch extends Component {
  setupDefaults() {
    this.landingURL = this.el.dataset.landingUrl;
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if (
      window.history.length > 1 &&
      document.referrer.includes(window.location.host) &&
      !document.referrer.includes(window.location.href)
    ) {
      window.history.back();
    } else {
      window.location.href = this.landingURL;
    }
  }
}

export default BackToSearch;
